
export const emailConfig = {
    serviceId: 'service_3izhxbj',        
    templateId: 'template_gpa45sn',      
    publicKey: 'I6IIyC5dxwKqR0Is4',
    recipientEmail: 'creativeknackshub@gmail.com',
};